export const TileAssets: Record<string, string> = {
    // Man (Characters)
    "man_1": "/tiles/1m.png",
    "man_2": "/tiles/2m.png",
    "man_3": "/tiles/3m.png",
    "man_4": "/tiles/4m.png",
    "man_5": "/tiles/5m.png",
    "man_5_red": "/tiles/0m.png",
    "man_6": "/tiles/6m.png",
    "man_7": "/tiles/7m.png",
    "man_8": "/tiles/8m.png",
    "man_9": "/tiles/9m.png",

    // Pin (Dots)
    "pin_1": "/tiles/1p.png",
    "pin_2": "/tiles/2p.png",
    "pin_3": "/tiles/3p.png",
    "pin_4": "/tiles/4p.png",
    "pin_5": "/tiles/5p.png",
    "pin_5_red": "/tiles/0p.png",
    "pin_6": "/tiles/6p.png",
    "pin_7": "/tiles/7p.png",
    "pin_8": "/tiles/8p.png",
    "pin_9": "/tiles/9p.png",

    // Sou (Bamboo)
    "sou_1": "/tiles/1s.png",
    "sou_2": "/tiles/2s.png",
    "sou_3": "/tiles/3s.png",
    "sou_4": "/tiles/4s.png",
    "sou_5": "/tiles/5s.png",
    "sou_5_red": "/tiles/0s.png",
    "sou_6": "/tiles/6s.png",
    "sou_7": "/tiles/7s.png",
    "sou_8": "/tiles/8s.png",
    "sou_9": "/tiles/9s.png",

    // Winds
    "wind_east": "/tiles/1z.png",
    "wind_south": "/tiles/2z.png",
    "wind_west": "/tiles/3z.png",
    "wind_north": "/tiles/4z.png",

    // Dragons
    "dragon_white": "/tiles/5z.png",
    "dragon_green": "/tiles/6z.png",
    "dragon_red": "/tiles/7z.png",

    // Back
    "back": "/tiles/back.png"
};
